import { connectCurrentRefinements } from "instantsearch.js/es/connectors";
import { provide, ref } from "vue";
export const useAisCurrentRefinements = (widgetParams, id = "") => {
  const stateRef = ref();
  const renderCurrentRefinements = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (isFirstRender) {
      provide(`currentRefinements-${id}`, stateRef);
    }
    return () => null;
  };
  const customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );
  return {
    ...customCurrentRefinements(widgetParams),
    $$widgetParams: widgetParams,
    $$widgetId: id
  };
};
